const routes = [{
    path: '/refrigeration',
    name: 'refrigeration',
    component: () => import('@src/modules/smartCold/view/index'),
    // redirect: '/refrigeration/fan',
    meta: {
      requireAuth: false
    },
    children: [{
        path: 'fan',
        name: 'fan',
        component: () => import('@src/modules/smartCold/view/fan-old'),
        meta: {
          requireAuth: false,
        }
      },
      {
        path: 'smokeFan',
        name: 'smokeFan',
        component: () => import('@src/modules/smartCold/view/fan'),
        meta: {
          requireAuth: false,
        }
      },
      {
        path: 'temperature',
        name: 'temperature',
        component: () => import('@src/modules/smartCold/view/temperature'),
        meta: {
          requireAuth: false,
        }
      },
      {
        path: 'fault',
        name: 'fault',
        component: () => import('@src/modules/smartCold/view/fault'),
        meta: {
          requireAuth: false
        }
      },
    ]
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import('@src/modules/smartCold/view/maintenance'),
    meta: {
      requireAuth: false,
    }
  },
  {
    path: '/analysis',
    name: 'analysis',
    component: () => import('@src/modules/smartCold/view/analysis'),
    meta: {
      requireAuth: false,
    }
  }

]

export default routes